import { WorkerManager } from './manager';
import IsolineJobManagerWorker from 'worker-loader!./isoline-job-manager-worker';

import { BufferedScalarField } from '../scalar-field/scalar-field-impl';
import { ScalarFieldIsolineRepresentation } from '../scalar-field/isoline';
import { ImpactMap } from '../scalar-field/scalar-field';

export class RenderManager extends WorkerManager {
	
	constructor(private resultHandler: (jobId: any, result: { representation: ScalarFieldIsolineRepresentation, impacts: ImpactMap })=>void) {
		super(new IsolineJobManagerWorker());
	}
	
    protected addListeners(): void {
		let handler = this;
		this.addListener('rendering', (jobId: any, result: { representation: ScalarFieldIsolineRepresentation, impacts: ImpactMap }) => {
			this.resultHandler(jobId, result);
		});
    }
    
//    public requestRendering = (scalarField: BufferedScalarField, thresholds: number[], stepSize: { x:number, y:number}): void => {
//		this.postMessage('render', scalarField.asWorkerArgument(), thresholds, stepSize);
//	}
    public requestRendering = (jobId: any, thresholds: number[], stepSize: { x:number, y:number}, smoothen = true, flatness = 1.0): void => {
		this.postMessage('render', jobId, {thresholds: thresholds, samplingStep:stepSize}, smoothen, flatness);
	}

}